import React, { useState } from 'react'; // eslint-disable-line

import { Button, Grid, Tooltip, Paper, withStyles } from '@material-ui/core';
import { AddCircle } from '@material-ui/icons';
import {
    Condition,
    True,
    WhenFieldChanges,
    FullWidthCheckBoxField,
    FormHeading,
} from '../../../../../forms';
import styles, { StyledComponent } from '../../../../../styles/styles';
import { BankingDetails } from '../../../common/banking-details/banking-details';
import { BankingDetailsViewComponent } from './edit-partial-bank-details';

interface ComponentState {
    bankingDetails: BankingDetails[];
}

interface Props extends ComponentState, StyledComponent {}

class MultipleBankingDetailsViewnViewClass extends React.Component<Props, ComponentState> {
    public constructor(props: Props) {
        super(props);
    }

    public componentDidMount() {
        this.setState({
            bankingDetails: this.props.bankingDetails,
        });
    }

    public render() {
        const classes = this.props ? this.props.classes : {};
        const bankingDetails = this.state ? this.state.bankingDetails : this.props.bankingDetails;
        const addEntry = (isChecked?: boolean) => {
            if (bankingDetails.length === 0 || isChecked) {
                bankingDetails.push({});
                this.setState({
                    bankingDetails: bankingDetails,
                });
            } else {
                bankingDetails.splice(0, bankingDetails.length);
                bankingDetails.push({});
                this.setState({
                    bankingDetails: bankingDetails,
                });
            }
        };
        const deleteEntry = (index: number) => {
            bankingDetails.splice(index, 1);
            this.setState({
                bankingDetails: bankingDetails,
            });
        };
        return (
            <Paper className={classes.paper}>
                <FormHeading text="Banking Details" />
                <Grid item xs={12}>
                    <FullWidthCheckBoxField
                        name="hasBankingDetails"
                        label="Add banking details"
                        onClick={() => addEntry(false)}
                    />
                </Grid>
                <WhenFieldChanges
                    field={`hasBankingDetails`}
                    set={`bankingDetails[${0}].investmentIdType`}
                    to="Individual"
                />
                <WhenFieldChanges
                    field={`hasBankingDetails`}
                    set={`bankingDetails[${0}]`}
                    to={null}
                />
                <Condition when="hasBankingDetails" is={true}>
                    <True>
                        <Paper className={classes.paper}>
                            {bankingDetails.map((bank, index) => {
                                return (
                                    <Grid
                                        item
                                        container
                                        spacing={5}
                                        key={`pm_${index}`}
                                        style={{ paddingLeft: '8px' }}
                                    >
                                        <BankingDetailsViewComponent
                                            index={index}
                                            deleteEntry={() => deleteEntry(index)}
                                            classes={classes}
                                        />
                                    </Grid>
                                );
                            })}
                            <Grid item xs={12} container justify="flex-end">
                                <WhenFieldChanges
                                    field={`hasBankingDetails`}
                                    set={`bankingDetails[${0}].investmentIdType`}
                                    to="Individual"
                                />
                                <Tooltip title="Add Banking Details">
                                    <Button
                                        id={'Add_banking_DEtails'}
                                        color="secondary"
                                        onClick={() => addEntry(true)}
                                    >
                                        <AddCircle />
                                        Add banking details
                                    </Button>
                                </Tooltip>
                            </Grid>
                        </Paper>
                    </True>
                </Condition>
            </Paper>
        );
    }
}
export const MultipleBankingDetailsView = withStyles(styles)(MultipleBankingDetailsViewnViewClass);
